import { render, staticRenderFns } from "./ShowSectionPage.vue?vue&type=template&id=15450bb8"
import script from "./ShowSectionPage.vue?vue&type=script&lang=js"
export * from "./ShowSectionPage.vue?vue&type=script&lang=js"
import style0 from "./ShowSectionPage.vue?vue&type=style&index=0&id=15450bb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports